import { IEntity, ITimePeriodEntity } from '@pf/shared-common';
import {
    CalendarType,
    FiscalPeriodSearchRequestParams,
    FiscalPeriodStatus,
    FiscalPeriodViewModelCreateBody,
    FiscalPeriodViewModelRead,
} from '@control-tower/platform-core';

export type FiscalPeriodRead = FiscalPeriodViewModelRead & IEntity;
export type FiscalPeriodCreate = FiscalPeriodViewModelCreateBody;
export type FiscalPeriodSearchParams = FiscalPeriodSearchRequestParams;

export class FiscalPeriodDto implements ITimePeriodEntity {
    constructor(data: Partial<FiscalPeriodDto>) {
        Object.assign(this, data);
    }

    id!: string;
    startDate!: string;
    endDate!: string;
    calendarType!: CalendarType;
    name!: string;
    description?: string | null;
    year!: number;
    quarter?: number | null;
    month?: number | null;
    week?: number | null;
    status!: FiscalPeriodStatus;
    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;
}
